var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "record-table-reference-number-with-hint" }, [
    _c("span", [_vm._v(_vm._s(_vm.text))]),
    _vm._v(" "),
    _vm.hint !== ""
      ? _c(
          "span",
          {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.hover.nofade.left.html",
                modifiers: {
                  hover: true,
                  nofade: true,
                  left: true,
                  html: true,
                },
              },
            ],
            staticClass: "record-table-reference-number-with-hint__badge",
            attrs: { title: _vm.hint },
          },
          [_vm._v("i")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }